import { render, staticRenderFns } from "./AUDIntegracaoSSFF.vue?vue&type=template&id=4c0ca0d2&"
import script from "./AUDIntegracaoSSFF.vue?vue&type=script&lang=js&"
export * from "./AUDIntegracaoSSFF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports